export const permissions = {
  ROLE_USER_NO_ACCEPTED_TERMS: {
    static: ["main:view"],
    dynamic: {},
  },
  ROLE_ADMIN: {
    static: [
      // Admin-specific permissions
      "adminMain:view",
      "adminSettings:view",
      "globalOrgDetails:view",
      "globalOrgDetails:change",

      // All ROLE_OWNER permissions
      "form-fill:page",
      "form-add-page:view",
      "admin:fetchOrgForms",
      "admin:fetchOrgUsers",
      "admin:editPerson",
      "main:view",
      "forms-page:view",
      "filled-forms-page:view",
      "groups-page:view",
      "admin:fetchOrgReports",
      "profilePage:view",
      "passwordChangePage:view",
      "add-persons-page:view",
      "orgDetails:change",
      "users:view",
      "users-filled-forms:view",
      "user-filled-all-forms-page:view",
      "new-test-kit:page",
      "orgDetails:view",
      "test-kit:page",
      "edit-test-kit:page",
      "admin:addGroup",
      "admin:fetchGroups",
      "form-group-add-page:view",
      "form-editor-page:view",
      "admin:setAdminRole",
      "form-fill-details:page",
      "activeforms-page:view",
      "form:deactivate",
      "form:duplicate",
      "form:edit",
      "form:remove",
      "form:add-to-project",
      "project:duplicate",
      "project:edit",
      "project:remove",
      "password-reset-email-link-expired:view",
      "results-page:view",
      "apikeys",
      "webhooks",
      "terms-page:view",
      "calendar:change",
      "calendar:view",
      "calendar:book-cancel-appointment",

      // All ROLE_EDITOR permissions
      "form:activate",
      "form:create",
      "forms:fetch",
      "groups:fetch",
      "editor:editPerson",
      "activated-kits-page:view",
    ],
    dynamic: {
      // Admin has all permissions unconditionally
      "form:deactivate": () => true,
      "form:duplicate": () => true,
      "form:edit": () => true,
      "form:remove": () => true,
      "form-add-page:view": () => true,
      "admin:fetchOrgUsers": () => true,
    },
  },
  ROLE_OWNER: {
    static: [
      "form-fill:page",
      "form-add-page:view",
      "admin:fetchOrgForms",
      "admin:fetchOrgUsers",
      "admin:editPerson",
      "main:view",
      "forms-page:view",
      "filled-forms-page:view",
      "groups-page:view",
      "admin:fetchOrgReports",
      "profilePage:view",
      "passwordChangePage:view",
      "add-persons-page:view",
      "orgDetails:change",
      "users:view",
      "users-filled-forms:view",
      "user-filled-all-forms-page:view",
      "new-test-kit:page",
      "orgDetails:view",
      "test-kit:page",
      "edit-test-kit:page",
      "admin:addGroup",
      "admin:fetchGroups",
      "form-group-add-page:view",
      "form-editor-page:view",
      "admin:setAdminRole",
      "form-fill-details:page",
      "activeforms-page:view",
      "form:deactivate",
      "form:duplicate",
      "form:edit",
      "form:remove",
      "form:add-to-project",
      "project:duplicate",
      "project:edit",
      "project:remove",
      "password-reset-email-link-expired:view",
      "results-page:view",
      "apikeys",
      "webhooks",
      "terms-page:view",
      "calendar:change",
      "calendar:view",
      "calendar:book-cancel-appointment",

      // Inherit ROLE_EDITOR permissions
      "form:activate",
      "form:create",
      "forms:fetch",
      "groups:fetch",
      "editor:editPerson",
      "activated-kits-page:view",
    ],
    dynamic: {
      // Owner has all permissions unconditionally
      "form:deactivate": () => true,
      "form:duplicate": () => true,
      "form:edit": () => true,
      "form:remove": () => true,
      "form-add-page:view": () => true,
      "admin:fetchOrgUsers": () => true,
    },
  },
  ROLE_SUPER_OPERATOR: {
    static: [
      "filled-forms-page:view",
      "results-page:view",
      "user-filled-all-forms-page:view",
      "form-fill-details:page",
    ],
    dynamic: {},
  },
  ROLE_EDITOR: {
    static: [
      "form-fill:page",
      "profilePage:view",
      "main:view",
      "forms-page:view",
      "activated-kits-page:view",
      "add-persons-page:view",
      "form-add-page:view",
      "form-editor-page:view",
      "form:activate",
      "form:create",
      "users-filled-forms:view",
      "user-filled-all-forms-page:view",
      "forms:fetch",
      "groups-page:view",
      "groups:fetch",
      "form-fill-details:page",
      "activeforms-page:view",
      "password-reset-email-link-expired:view",
      "editor:editPerson",
      "filled-forms-page:view",
      "results-page:view",
      "apikeys",
      "calendar:change",
      "calendar:view",
      "calendar:book-cancel-appointment",
    ],
    dynamic: {
      // Editor permissions depend on organization settings
      "form:deactivate": (store) => store?.organization?.editorsCanManageForms,
      "form:duplicate": (store) => store?.organization?.editorsCanManageForms,
      "form:edit": (store) => store?.organization?.editorsCanManageForms,
      "form:remove": (store) => store?.organization?.editorsCanManageForms,
      "form-add-page:view": (store) =>
        store?.organization?.editorsCanManageForms,
      "admin:fetchOrgUsers": (store) =>
        store?.organization?.editorsCanManageUsers,
    },
  },
  ROLE_PATIENT: {
    static: [
      "main:view",
      "profilePage:view",
      "passwordChangePage:view",
      "form-fill:page",
      "form-fill-details:page",
      "activeforms-page:view",
      "filled-kits:page",
      "test-kit:page",
      "edit-test-kit:page",
      "shopping-cart:page",
      "orders:page",
      "order-in-progress:page",
      "activated-kits-page:view",
      "sat-form:page",
      "password-reset-email-link-expired:view",
      "calendar:view",
      "calendar:book-cancel-appointment",
    ],
    dynamic: {},
  },
  GUEST: {
    static: [
      "login:view",
      "help:view",
      "about:view",
      "password-reset-email:view",
      "password-reset-email-link-expired:view",
    ],
    dynamic: {},
  },
};

/**
 * Check if user has admin-level access (ROLE_ADMIN, ROLE_OWNER, or ROLE_EDITOR)
 */
export const hasAdminAccess = (roles) => {
  if (!roles) return false;
  return roles.some(role =>
    role === "ROLE_ADMIN" ||
    role === "ROLE_OWNER" ||
    role === "ROLE_EDITOR"
  );
};

/**
 * Check if user has owner-level access (ROLE_ADMIN or ROLE_OWNER)
 * Use this instead of checking for ROLE_OWNER directly
 */
export const hasOwnerAccess = (roles) => {
  if (!roles) return false;
  return roles.some(role =>
    role === "ROLE_ADMIN" ||
    role === "ROLE_OWNER"
  );
};

/**
 * Check if user has editor-level access (ROLE_ADMIN or ROLE_EDITOR)
 * Use this instead of checking for ROLE_EDITOR directly
 */
export const hasEditorAccess = (roles) => {
  if (!roles) return false;
  return roles.some(role =>
    role === "ROLE_ADMIN" ||
    role === "ROLE_EDITOR"
  );
};

/**
 * Check if authorities string contains owner role (ROLE_ADMIN or ROLE_OWNER)
 * For backward compatibility with code using authorities string
 */
export const isOwnerRole = (authorities) => {
  if (!authorities) return false;
  return authorities.includes("ROLE_ADMIN") || authorities.includes("ROLE_OWNER");
};

/**
 * Check if authorities string contains editor role (ROLE_ADMIN or ROLE_EDITOR)
 * For backward compatibility with code using authorities string
 */
export const isEditorRole = (authorities) => {
  if (!authorities) return false;
  return authorities.includes("ROLE_ADMIN") || authorities.includes("ROLE_EDITOR");
};

export const checkPermission = (permission, roles, store) => {
  let allPermissions = [];
  if (!roles) {
    allPermissions = [...permissions.GUEST.static];
  } else {
    roles.forEach((role) => {
      if (permissions[role]) {
        allPermissions = [...allPermissions, ...permissions[role].static];

        if (store && permissions[role].dynamic[permission]) {
          if (permissions[role].dynamic[permission](store)) {
            allPermissions.push(permission);
          }
        }
      }
    });
  }

  const result = allPermissions.indexOf(permission) !== -1;

  if (!result) {
    console.debug("no permission for", permission);
  }

  return result;
};
